var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppButtonOk',{attrs:{"disabled":_vm.form.basicSetting.isMenuIdEmpty ||
      _vm.form.basicSetting.name === '' ||
      _vm.form.deliverySetting.menuSetting.simulationLocationsAllCount > 20000,"color":"primary"},on:{"click":_vm.onSave}},[_vm._v("\n  保存\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }